// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#vue-wp-app .fade-up[data-v-2aa4a302]{opacity:0;transform:translateY(20px);animation:fadeUp-2aa4a302 .5s forwards}@keyframes fadeUp-2aa4a302{to{opacity:1;transform:translateY(0)}}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
